import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import styled, { keyframes, useTheme } from 'styled-components';
import { resolvePalette } from '@blade/ui-theme';
// From figma
const DIAMETER_STROKE_RATIO = 0.125;
export const CircularLoader = ({ className, size = 34, color = 'background', spinning = 'normal', }) => {
    const theme = useTheme();
    const viewBoxSize = size;
    const stroke = size * DIAMETER_STROKE_RATIO;
    const safeCenter = viewBoxSize / 2 - stroke / 2;
    const firstHalfId = useId();
    const secondHalfId = useId();
    const mainColor = color === 'gray-inverse'
        ? 'var(--appearance-1)'
        : resolvePalette(theme, color)[12];
    return (_jsx(Root, { className: className, "$spinning": spinning, children: _jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: `0 0 ${viewBoxSize} ${viewBoxSize}`, fill: "none", color: mainColor, children: [_jsxs("defs", { children: [_jsxs("linearGradient", { id: secondHalfId, children: [_jsx("stop", { offset: "0%", stopOpacity: "0.1", stopColor: "currentColor" }), _jsx("stop", { offset: "100%", stopOpacity: "0.5", stopColor: "currentColor" })] }), _jsxs("linearGradient", { id: firstHalfId, children: [_jsx("stop", { offset: "0%", stopOpacity: "1", stopColor: "currentColor" }), _jsx("stop", { offset: "100%", stopOpacity: "0.5", stopColor: "currentColor" })] })] }), _jsxs("g", { strokeWidth: stroke, children: [_jsx("path", { stroke: `url(#${secondHalfId})`, d: `M ${stroke / 2} ${viewBoxSize / 2} A ${safeCenter} ${safeCenter} 0 0 1 ${viewBoxSize - stroke / 2} ${viewBoxSize / 2}` }), _jsx("path", { stroke: `url(#${firstHalfId})`, d: `M ${viewBoxSize - stroke / 2} ${viewBoxSize / 2} A ${safeCenter} ${safeCenter} 0 0 1 ${stroke / 2} ${viewBoxSize / 2}` }), _jsx("path", { stroke: "currentColor", strokeLinecap: "round", d: `M ${stroke / 2} ${viewBoxSize / 2} A ${safeCenter} ${safeCenter} 0 0 1 ${stroke / 2} ${viewBoxSize / 2 - stroke / 4}` })] })] }) }));
};
const Rotate = keyframes `
   0% {
    transform: rotate(0deg);
   }
   100% {
    transform: rotate(360deg);
   }
`;
const Root = styled.div `
  display: inline-grid;
  font-size: 0;

  animation-name: ${({ $spinning }) => $spinning === 'normal' ? Rotate : undefined};
  animation-duration: 1.3s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
`;
//# sourceMappingURL=circular-loader.js.map